import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useMasterAccountheadsQuery } from "../../../services/accountHeadApi";
import { signInUser } from "../../Utility/Auth";

const SelectAChead = ({ mc, handleOnchange }) => {
  const auth = signInUser();
  const { aamarId } = auth || {};
  const { data, error, isLoading, isFetching, isSuccess } =
    useMasterAccountheadsQuery({ aamarId }, { skip: !aamarId });
  let [mcData, setMcData] = useState([]);

  // Effect to load master account data
  useEffect(() => {
    let mcs = [{ option: "no-master", value: "no-master", label: "Select Master AccountHead" }];
    if (isSuccess && data && data.length > 0) {
      const formatted = data.map((item) => ({
        ...item,
        option: item._id,
        value: item._id,
        label: `${item.name} - ${item.code}`,
        code: item.code,
      }));
      setMcData([...mcs, ...formatted]);
    } else {
      setMcData(mcs);
    }
  }, [data, isSuccess]);

  // Handle clearing selection
  const handleClearSelection = () => {
    if (handleOnchange) {
      handleOnchange(null);
    }
  };

  const mcId =
    typeof mc === "object" && mc !== null
      ? mc.option || mc.value || mc._id
      : mc;

  const selectedOption =
    mcId && mcId !== "no-master"
      ? mcData.find((obj) => obj.option === mcId || obj.value === mcId) || null
      : null;

  return (
    <Fragment>
      <Select
        className="basic-single"
        classNamePrefix="select"
        isDisabled={false}
        isLoading={isLoading}
        isClearable={true}
        value={selectedOption}
        isSearchable={true}
        name="mc"
        onChange={handleOnchange}
        onClear={handleClearSelection}
        options={mcData}
      />

      <div
        style={{
          color: "hsl(0, 0%, 40%)",
          display: "inline-block",
          fontSize: 12,
          fontStyle: "italic",
          marginTop: "1em",
        }}
      ></div>
    </Fragment>
  );
};

export default SelectAChead;
